import { FetchRequest } from '@rails/request.js'

interface CreateArgs {
  accountNumber: string
  containerSessionId?: string
  repCodeValue: string
  submissionContainerId: string
}

interface DestroyArgs {
  accountNumber: string
  submissionContainerId: string
}

// TODO: Account: both endpoints take an account number because a group has no
// record of its own. They take an id once Account does.
export function create({ accountNumber, containerSessionId, repCodeValue, submissionContainerId }: CreateArgs) {
  const endpoint = `/submission_containers/${submissionContainerId}/accounts`
  const body = new FormData()
  body.append('account_number', accountNumber)
  body.append('rep_code_value', repCodeValue)
  // Which tab is asking, so the starter submission comes back open for editing.
  if (containerSessionId) body.append('container_session_id', containerSessionId)

  return new FetchRequest('post', endpoint, { body, responseKind: 'turbo-stream' }).perform()
}

export function destroy({ accountNumber, submissionContainerId }: DestroyArgs) {
  const endpoint = `/submission_containers/${submissionContainerId}/accounts/${accountNumber}`

  return new FetchRequest('delete', endpoint, { responseKind: 'turbo-stream' }).perform()
}
